import { alertConstants } from "../_constants"

const initialState = {
    notification: {
        message: "",
        level: "",
        visible: false
    },
}

export function alert(state = initialState, action: any){
    switch(action.type) {
        case alertConstants.ALERT_SHOW:
        return {
            ...state,
            notification: action.notification,
            visible: true
        }
        case alertConstants.ALERT_HIDE:
        return {
            ...state,
            notification: initialState.notification,
            visible: false
        }
        default:
            return state;
    }
}